<template>
  <div
    class="wfs_container"
    :class="{
      collapsed,
    }"
  >
    <div class="header_section">
      <div v-if="!collapsed" class="status_name" v-text="status.name" />
      <div class="action">
        <template v-if="!collapsed">
          <BaseButton
            v-if="folderCount > 0"
            color="primary"
            type="primary"
            class="mr-2"
            @click="openRelanchMass"
          >
            {{ $t("folder.relaunch") }}
          </BaseButton>
          <div class="collapse_btn folder_number" v-text="folderCount" />
        </template>
        <v-btn class="collapse_btn" small icon @click="toggleCollapsed()">
          <v-icon> $mdiChevronLeft </v-icon>
        </v-btn>
      </div>
    </div>
    <div class="body_section"
      @drop="onDrop($event, status)"
      @dragover.prevent
      @dragenter.prevent>
      <div v-if="collapsed" class="header_section">
        <div class="action">
          <div class="folder_number" v-text="folderCount" />
        </div>
        <div class="status_name" v-text="status.name" />
      </div>
      <template v-else>
        <div ref="folderPerContactList">
          <div
            v-for="folderPerContact in foldersPerContact.items"
            :key="`wfci-${status.id}-${folderPerContact.id}`"
            >
            <span v-text="folderPerContact.email" />
            <div
              v-for="folder in folderPerContact.folders"
              :id="`wfi-${status.id}-${folderPerContact.id}-${folder.id}`"
              :key="`wfi-${status.id}-${folderPerContact.id}-${folder.id}`"
              draggable
              @dragstart="onDragstart($event, folder, status)"
            >
              <router-link
                class="folder_item"
                draggable="false"
                :data-folder-id="folder.id"
                :data-collaborator-id="
                  (folder.collaborator && folder.collaborator.id) || 1
                "
                :to="{
                  name: 'folderDetail',
                  params: {
                    organizationId: $route.params.organizationId,
                    folderId: folder.id,
                  },
                }"
              >
                <div class="folder_name" v-text="folder.name" />
                <div
                  v-if="folder.contact"
                  class="contact"
                  v-text="folder.contact.email"
                />
                <div
                  v-if="folder.collaborator"
                  class="collaborator"
                  v-text="folder.collaborator.email"
                />
                <div v-if="folder.displayCompletionRate" class="completion_rate">
                  <v-progress-linear
                    :value="folder.completionRateValue"
                    color="light-blue"
                    striped
                    height="20"
                  >
                    <div
                      class="completion_rate_label"
                      v-text="folder.completionRateLabel"
                    />
                  </v-progress-linear>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div v-intersect="loadMoreFoldersPerContact" class="intersection" />
        <div v-if="fetchingFolders">
          <div v-for="value in 4" :key="value" class="folder_skeleton">
            <v-skeleton-loader class="skeleton" type="text" />
          </div>
        </div>
        <div
          v-if="!fetchingFolders && !foldersPerContact.items.length"
          class="no_folder"
          v-text="$t('utils.no_folder_for_status')"
        />
      </template>
    </div>
  </div>
</template>
<script>
import FolderAPI from "@/modules/Folder/Services/folder.api";
import WorkflowAPI from "@/modules/Admin/Services/workflow.api";
import { WorkflowFolderPerContact } from "@/core/Models/Folder";

export default {
  name: "WorkflowFolderStatus",
  props: {
    status: {
      type: Object,
      required: true,
    },
    wfStatuses: {
      type: Array,
      required: true,
    },
    filterByContact: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      collapsed: false,
      fetchingFolders: true,
      foldersPerContact: {
        count: 0,
        next: 0,
        previous: 0,
        items: [],
      },
      filters: {
        page_size: 10,
        page: 1,
        searchTimeoutRef: undefined,
      },
      folderCount: 0,
    };
  },
  watch: {
    filterByContact: function() {
      this.filterContacts();
    },
  },
  created() {
    this.fetchFoldersPerContact();
  },
  methods: {
    filterContacts() {
      this.filters.page = 1;
      if (this.filters.searchTimeoutRef) {
        clearTimeout(this.filters.searchTimeoutRef);
      }
      this.filters.searchTimeoutRef = setTimeout(async () => {
        this.foldersPerContact = { count: 0, next: 0, previous: 0, items: [] };
        this.filters = { page_size: 10, page: 1, searchTimeoutRef: undefined };
        this.fetchFoldersPerContact();
      }, 200);
    },
    async fetchFoldersPerContact() {
      this.fetchingFolders = true;
      try {
        let params = {
          page: this.filters.page,
          page_size: this.filters.page_size,
        };
        if (this.filterByContact != null) {
          params["q"] = this.filterByContact;
        }
        const res = await WorkflowAPI.getWorkflowFolderPerContact({
          organizationId: this.$route.params.organizationId,
          workflowId: this.$route.params.workflowId,
          statusId: this.status.id,
          params: params,
        });
        
        this.foldersPerContact = {
          ...res.data,
          items: [...this.foldersPerContact.items, ...res.data.results].map(
            (f) => new WorkflowFolderPerContact(f)
          ),
        };
        this.updateFolderCount();
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.fetchingFolders = false;
    },
    async loadMoreFoldersPerContact(_, __, isIntersecting) {
      if (!isIntersecting || this.fetchingFolders || !this.foldersPerContact.next) return;
      this.filters.page = this.foldersPerContact.next;
      this.fetchFoldersPerContact();
    },
    updateFolderCount() {
      let folderCount = 0;
      for (const folderPerContact of this.foldersPerContact.items) {
        folderCount += folderPerContact.folders.length;
      }
      this.folderCount = folderCount;
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    openRelanchMass() {
      this.$emit("openRelanchMass", this.status);
    },
    async onDragEnd(event) {
      const folderId = event.item.dataset.folderId;
      const newStatusId = event.to.dataset.statusId;
      const oldStatusId = event.from.dataset.statusId;
      if (newStatusId !== oldStatusId) {
        try {
          await FolderAPI.putFolderStatus(
            this.$route.params.organizationId,
            folderId,
            Number.parseInt(newStatusId)
          );
          this.$store.dispatch("snackbar/active", {
            message: this.$t("folder.statusForm.success"),
            type: "SUCCESS",
          });
        } catch {
          this.$store.dispatch("snackbar/active", {
            message: this.$t("folder.statusForm.error"),
            type: "ERROR",
          });
        }
      }
    },
    onDragstart(event, folder, status) {
      event.dataTransfer.setData("application/elementId", event.target.id);
      event.dataTransfer.setData("application/folderId", folder.id);
      event.dataTransfer.setData("application/statusId", status.id);
      event.dataTransfer.dropEffect = "move";
      event.target["dragend"] = () => {
        this.foldersPerContact.items = this.foldersPerContact.items.map((folderPerContact) => {
          return {
            ...folderPerContact,
            folders: folderPerContact.folders.filter((f) => f.id != folder.id),
          };
        });
        this.updateFolderCount();
      };
    },
    async onDrop(event, status) {
      event.preventDefault();
      const elementId = event.dataTransfer.getData("application/elementId");
      const element = document.getElementById(elementId);
      const folderId = event.dataTransfer.getData("application/folderId");
      const oldStatusId = event.dataTransfer.getData("application/statusId");
      const newStatusId = status.id;
      if (newStatusId !== oldStatusId) {
        try {
          await FolderAPI.putFolderStatus(
            this.$route.params.organizationId,
            folderId,
            Number.parseInt(newStatusId)
          );

          element.dragend();
          element.remove();
          this.foldersPerContact = {
            count: 0,
            next: 0,
            previous: 0,
            items: [],
          };
          this.filters = {
            page_size: 10,
            page: 1,
          };
          this.$refs.folderPerContactList.innerHTML = "";
          await this.fetchFoldersPerContact();

          this.$store.dispatch("snackbar/active", {
            message: this.$t("folder.statusForm.success"),
            type: "SUCCESS",
          });
        } catch {
          this.$store.dispatch("snackbar/active", {
            message: this.$t("folder.statusForm.error"),
            type: "ERROR",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wfs_container {
  width: 350px;
  border: 0.5px solid #ecebf1;
  border-radius: 4px;
  flex: none;
  overflow: hidden;
  .header_section {
    background: #e6eff4;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 4px;
    transition: all 0.3s ease-in;
    .status_name {
      flex: 1;
      padding: 0 12px;
      font-size: 18px;
      line-height: 20px;
      text-transform: capitalize;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: all 0.25s ease-in-out;
    }
    .action {
      display: flex;
      align-items: center;
      .collapse_btn {
        transition: all 0.3s ease-in;
      }
      .folder_number {
        height: 20px;
        padding: 4px;
        margin: 4px;
        font-size: 11px;
        list-style: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        background: #2536cc;
        border-radius: 5px;
      }
    }
  }
  .body_section {
    padding: 12px;
    width: 100%;
    height: calc(100% - 40px);
    overflow: hidden;
    overflow-y: auto;
    background: #fff;
    position: relative;
    .header_section {
      width: 350px;
      top: 160px;
      left: 50%;
      position: absolute;
      transform-origin: center center;
      transform: translate(-50%, 0) rotate(90deg);
      background: #fff;
      transition: none;
    }
    .folders_list {
      min-height: 100%;
    }
    .folder_item {
      display: block;
      border: 4px;
      padding: 12px;
      margin-bottom: 16px;
      background: #f4f7ff;
      cursor: pointer;
      text-decoration: none;
      color: inherit;
      &:hover, &:visited, &:active {
        text-decoration: none;
        color: inherit;
      }
      .folder_name {
        font-size: 14px;
        line-height: 20px;
        font-weight: bold;
      }
      .contact {
        font-size: 13px;
        line-height: 18px;
      }
      .collaborator {
        font-size: 10px;
        list-style: 10px;
        text-align: right;
        color: #4f4f4f;
      }
      .completion_rate {
        margin-top: 8px;
        .completion_rate_label {
          font-size: 10px;
          text-align: center;
          color: #333;
        }
      }
    }
    .dragged_item {
      outline: 1px dashed #2536cc;
      opacity: 0.5;
    }
    .folder_skeleton {
      width: 100%;
      margin-bottom: 16px;
      height: 85px;
    }
    .intersection {
      height: 10px;
    }
    .skeleton {
      height: 100%;
      width: 100%;
      ::v-deep {
        .v-skeleton-loader__bone {
          height: 100%;
        }
      }
    }
    .no_folder {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
      color: #bdbdbd;
      text-align: center;
    }
  }
  &.collapsed {
    width: 40px;
    flex: none;
    .header_section {
      padding: 0px;
      align-items: center;
      justify-content: center;
      .action {
        margin: 0;
        .collapse_btn {
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>
